export default "__VITE_ASSET__CkyAyJU6__"